import React from 'react';
import { Icon } from './Icon.js';
export const IconHeadset = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22H19L21 18.7198V18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M3.11282 12H7V18H3V11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11V18H17V12H20.8923", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconHeadset.js.map